import { z } from 'zod';

// https://docs.slace.com/docs/stoplight-docs-core/f62ef79f8baa5-event
export const schemaSlaceEvent = z
    .object({
        body: z.record(z.unknown()).optional(),
        channel_id: z.string(),
        // Contact's concrete communication channel
        com_channel_id: z.string().optional(),
        // Contact id from Slace system
        contact_id: z.string().optional(),
        // Contact's conversation id
        conversation_id: z.string().optional(),
        gateway_id: z.string().optional(),
        // Random string will be generated if empty
        id: z.string().optional(),
        // Some common identifier of source (like module or app name)
        source: z.string(),
        // Current time will be set if empty
        timestamp: z.string().optional(),
        transaction_id: z.string().optional(),
        // Event name
        type: z.string(),
    })
    .superRefine((data, ctx) => {
        if (!data.channel_id && !data.com_channel_id && !data.conversation_id) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'At least one of channel_id, com_channel_id or conversation_id should be provided',
            });
        } else {
            if (data.contact_id && (data.com_channel_id || data.conversation_id)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'contact_id should not be provided with com_channel_id or conversation_id',
                });
            }
            if (data.com_channel_id && (data.contact_id || data.conversation_id)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'com_channel_id should not be provided with contact_id or conversation_id',
                });
            }
            if (data.conversation_id && (data.contact_id || data.com_channel_id)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'conversation_id should not be provided with contact_id or com_channel_id',
                });
            }
        }
    });

export type SchemaSlaceEvent = z.infer<typeof schemaSlaceEvent>;
